import { gql } from '@apollo/client';

/**
 * GraphQL mutation to update policy content for a standard label
 */
export const UPDATE_LABEL_POLICY_CONTENT = gql`
  mutation UpdateLabelPolicyContent($labelId: ID!, $content: String!) {
    updateLabelPolicyContent(labelId: $labelId, content: $content) {
      success
      message
      labelId
      policyFile
    }
  }
`;
